import { Module } from "wrapper6";
import Glide from '@glidejs/glide';

export default class QuoteSlider extends Module {

    ready(app) {
        this.SLIDER_CONTAINERS = document.querySelectorAll('.quote-slider');

        this.init();
    }

    init() {
        if(this.SLIDER_CONTAINERS){
            for (let i = 0; i < this.SLIDER_CONTAINERS.length; i++) {
                const SLIDER_CONTAINER = this.SLIDER_CONTAINERS[i];
                const CONTROLS = SLIDER_CONTAINER.querySelectorAll('.controls .dash');

                if(SLIDER_CONTAINER.className.indexOf('enable') !== -1) {

                    let slider = new Glide(SLIDER_CONTAINER.querySelector('.slider-container'), {
                        type: 'slider',
                        startAt: 0,
                        perView: 1,
                        gap: 30,
                        bound: true,
                        autoplay: 5000,
                    }).mount();

                    slider.on('run', function() {
                        if(CONTROLS){
                            SLIDER_CONTAINER.querySelector('.controls .dash.active').classList.remove('active');
                            SLIDER_CONTAINER.querySelector('.controls .dash[data-id="'+slider.index+'"]').classList.add('active');
                        }
                        SLIDER_CONTAINER.querySelector('.object-fit.active').classList.remove('active');
                        SLIDER_CONTAINER.querySelector('.object-fit[data-id="'+slider.index+'"]').classList.add('active');
                    });

                    for (let i = 0; i < CONTROLS.length; i++) {
                        const DASH = CONTROLS[i];
                        DASH.addEventListener("click", () => {
                            const ID = DASH.getAttribute('data-id');
            
                            slider.go('='+ID);
                        });
                    }
                }
            }
        }
    }
}